module.exports = __webpack_public_path__ + "img/barach_no.7661cbf8.png";